import Vue from 'vue';
import {
  Pagination,
  Dialog,
  Menu,
  Submenu,
  Progress,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  DatePicker,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Collapse,
  CollapseItem,
  Option,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Row,
  Col,
  Upload,
  Card,
  Cascader,
  Container,
  Header,
  Aside,
  Footer,
  Main,
  MessageBox,
  Message,
  Scrollbar,
  Transfer,
  Loading,
  Carousel,
  CarouselItem,
  Popover,
  Steps,
  Step,
  Popconfirm,
} from 'element-ui';

Vue.use(Popconfirm);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Transfer);
Vue.use(Progress);
Vue.use(CollapseItem);
Vue.use(Collapse);
Vue.use(Dialog);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatePicker);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Card);
Vue.use(Cascader);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Scrollbar);
Vue.use(Loading.directive);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = function (type, message) {
  Message({
    type,
    message,
    offset: 140,
  });
};
